module.exports = __webpack_public_path__ + "img/MapPicsWateringHole.8fc41310.webp";